import React, {useEffect, useRef} from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();
  const scrollRef = useRef(0);

  const handleLinkClick = () => {
    scrollRef.current = window.pageYOffset;
    window.scrollTo(0, scrollRef.current);
    setTimeout(function(){
        window.scrollTo(0, 0);
    },600)
  };

  return (
    <>
      <div className="scrollNav">
        <ul>
          <li className={location.pathname === "/daejeon/" ? 'active' : ''}><Link to="/" onClick={handleLinkClick}><strong>Intro</strong></Link></li>
          <li className={location.pathname === "/daejeon/lobby" ? 'active' : ''}><Link to="/daejeon/lobby" onClick={handleLinkClick}><strong>Lobby</strong></Link></li>
          <li className={location.pathname === "/daejeon/lounge" ? 'active' : ''}><Link to="/daejeon/lounge" onClick={handleLinkClick}><strong>Lounge</strong></Link></li>
          <li className={location.pathname === "/daejeon/privateroom" ? 'active' : ''}><Link to="/daejeon/privateroom" onClick={handleLinkClick}><strong>Private Room</strong></Link></li>
        </ul>
      </div>
    </>
  );
}

export default Navbar;